import axios from 'axios'
import Vue from 'vue';
import router from "@/router";

const buildErrorResponse = (err) => {
    /**
     * 接口返回统一格式定义
     */
    let res = {
        data: {
            resCode: 999,
            resMsg: '网络不给力，重试一下吧～'
        },
        status: 999,
        statusText: '网络错误',
        config: {},
        headers: {}
    }

    if (err.response) {
        res = err.response
    } else {
        res.config = err.config
    }

    // 发生错误，服务端返回404，500一个html串
    if (typeof res.data !== 'object') {
        res.data = {
            resCode: 999,
            msg: '网络不给力，重试一下吧～'
        }
    }
    return res
}

export const request = async ({
    url = '',
    method = 'GET',
    data = {},
    params = {},
    timeout = 120000,
    withCredentials = true,
    headers = {
        'Content-Type': 'application/json'
    },

}, {
    autoToastError = true
} = {}) => {
    let res;
    try {
        //baseUrl=process.env.NODE_ENV === 'development' ?  "/": process.env.VUE_APP_BASE_API;
        let baseUrl=Vue.prototype.GLOBAL.SERVER_HOST;
        res = await axios({
            url: `${baseUrl}${url}`,
            method,
            data,
            params,
            timeout,
            headers,
            //跨域请求是否需要凭证，默认false
            withCredentials
        })
    } catch (err) {
        res = buildErrorResponse(err)
    }


    if (autoToastError) {
        try {
            if (res.data) {
                if (res.data.status == "401") {
                    //跳转登录页面
                    // console.log('未登录')
                    router.push({path: res.data.info,query:{t: Date.now()}});
                } else if (res.data.status == 402) {
                    //跳转管理登录页面
                    // console.log('无管理权限')
                    router.push({path: res.data.info,query:{t: Date.now()}});
                } else if (res.data.status == "success") {
                    return res.data
                } else {
                    Vue.prototype.$notify.error({
                        title: '错误',
                        message: res.data.info
                    });
                }
            } else {
                Vue.prototype.$notify.error({
                    title: '错误',
                    message: res.data.info
                });
                return null;
            }
        } catch (err) {
            res = buildErrorResponse(err);
        }
    }else{
        console.log(autoToastError)
    }

}
